import { asyncAction } from 'lib/actionCreators'
import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const points = asyncAction('recruiter/POINTS')
export const receivedPoints = asyncAction('recruiter/RECEIVED_POINTS')
export const rewardsView = createRoutine('recruiter/REWARDS_VIEW')
export const redeem = createRoutine('recruiter/REDEEM')
export const rewardsViewPromiseCreator = promisifyRoutine(rewardsView)
export const redeemPromiseCreator = promisifyRoutine(redeem)
